// extracted by css-extract-rspack-plugin
export default {"Result":"Result-module__Result__I0WVD"};